import styled from 'styled-components';
import { breakpoints as bp, themeGet } from '@firsttable/web-theme';
import media from 'styled-media-query';
import Box from '../Box';

const SwitchBorder = styled(Box)`
  position: relative;
  border: 1px solid ${themeGet('colors.grayscale.300')};
  height: 37px;
  border-radius: 5px;
  background-color: ${themeGet('colors.grayscale.200')};
  width: ${({ width }) => width || '260px'};
  ${media.lessThan(bp.s)`
    width: 100%;
    margin: 10px 0;
  `};
`;

export default SwitchBorder;
